"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Modal_1 = __importDefault(require("react-bootstrap/Modal"));
var CatalogCluezDownloadModal_module_scss_1 = __importDefault(require("./CatalogCluezDownloadModal.module.scss"));
var modalGroupIdChecked = '', catalogDlCount = 0;
var catalogDlIntervalId;
var catalogDl = function (cid) {
    if (catalogDlCount == 1) {
        return;
    }
    if (catalogDlCount == 0) {
        catalogDlCount = catalogDlCount + 1;
    }
    catalogDlIntervalId = setInterval(function () {
        try {
            var dlIframe = $('#dliframe');
            dlIframe.css({ width: '100%' });
            if (dlIframe == undefined) {
                return;
            }
            if (dlIframe.contents().find('#userInputModal').hasClass('in') == false) {
                dlIframe
                    .contents()
                    .find('#catalog_dl_script')
                    .attr({ onclick: "dl('" + cid + "')" });
                dlIframe.contents().find('#catalog_dl_script').trigger('click').done;
                dlIframe.contents().find('#userInputModal').find('.modal-dialog.modal-lg').css({
                    margin: 0,
                    padding: 0,
                    width: '100%',
                });
                dlIframe.contents().find('#userInputModal').find('.modal-content').css({
                    border: 'none',
                    'border-radius': 0,
                    'box-shadow': 'none',
                    'background-color': 'transparent',
                });
            }
            if (dlIframe[0] == undefined) {
                return;
            }
            if (dlIframe[0].contentWindow != undefined) {
                var ifrmDoc = dlIframe[0].contentWindow.document;
                var modalHtml = $('.modal-dialog', ifrmDoc);
                if (modalHtml.height() != dlIframe.css('height').replace(/[^0-9]/g, '')) {
                    dlIframe.css({ height: modalHtml.height() });
                }
            }
            if (dlIframe.contents().find('.target-1').hasClass('jsc-dn')) {
                $('#downloadStart').remove();
            }
            if (dlIframe.contents().find('body').hasClass('jsc-loading') && !$('#downloadStart')[0]) {
                var downloadStart = $('<div/>').attr('id', 'downloadStart');
                downloadStart.css({
                    'z-index': '9999',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    height: $('html').get(0).scrollHeight + 'px',
                });
                $('body').append(downloadStart);
            }
        }
        catch (e) {
            // モーダルを閉じるタイミングでエラーが出る場合がある
            console.log('error on catalogDl()', e);
            return;
        }
    }, 400);
};
var CatalogCluezDownloadModal = function (props) {
    var catalogId = props.catalogId, companyId = props.companyId, requestId = props.requestId;
    var _a = __read(react_1.useState(false), 2), show = _a[0], setShow = _a[1];
    var _b = __read(react_1.useState(), 2), iframeContent = _b[0], setIframeContent = _b[1];
    var catalogDlMain = function () {
        var domain = ''; // 環境設定
        if (document.domain.indexOf('test') > -1 || document.domain.indexOf('local') > -1) {
            domain = 'www.test.aperza.com';
        }
        else if (document.domain.indexOf('stg') > -1) {
            domain = 'www.stg.aperza.com';
        }
        else {
            domain = 'www.aperza.com';
        }
        $.ajax({
            type: 'POST',
            url: 'https://' + domain + '/download/catalog-dl',
            data: { modalDlGroupNameSet: modalGroupIdChecked },
            xhrFields: {
                withCredentials: true,
            },
            success: function (response) {
                setIframeContent(response);
                if (window.aperza) {
                    window.aperza.aw.catalogCluezDownloadModal = new Date().getTime();
                }
                return;
            },
            error: function (response, bb, errorThrown) {
                console.error(response.responseText);
                if (window.aperza) {
                    window.aperza.aw.catalogCluezDownloadModalError = response.responseText;
                }
                // alert(JSON.parse(response.responseText));
                // location.reload();
            },
        });
    };
    react_1.useEffect(function () {
        catalogDlMain();
    }, []);
    react_1.useEffect(function () {
        if (companyId && catalogId && iframeContent) {
            setShow(true);
        }
    }, [requestId, catalogId, companyId]);
    react_1.useEffect(function () {
        if (show) {
            var iframe = document.getElementById('dliframe');
            var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            iframeDoc.write(iframeContent);
            iframeDoc.close();
            catalogDl(companyId + '_' + catalogId);
        }
    }, [show]);
    var onModalClose = function () {
        clearInterval(catalogDlIntervalId);
        setShow(false);
        var dlIframe = $('#dliframe');
        dlIframe.remove();
        catalogDlCount = 0;
    };
    return (react_1.default.createElement(Modal_1.default, { show: show, onHide: onModalClose, onClick: onModalClose, size: 'lg', dialogClassName: CatalogCluezDownloadModal_module_scss_1.default.modal, id: "catalogDownloadModal" },
        react_1.default.createElement(Modal_1.default.Body, { className: "p-0" },
            react_1.default.createElement("div", { id: "modal-catalog-dl" },
                react_1.default.createElement("iframe", { id: 'dliframe', className: 'dliframe', style: { width: '100%', height: '0px', border: 0 } })))));
};
CatalogCluezDownloadModal.propTypes = {
    catalogId: prop_types_1.default.number,
    companyId: prop_types_1.default.number,
    requestId: prop_types_1.default.any,
};
exports.default = CatalogCluezDownloadModal;
